/**
 * SHARED
 * Cross-cutting code usable by any module. Must not import from any module.
 */

import { Navigate, useLocation } from "react-router-dom";
import { useSession } from "./SessionProvider.jsx";

export default function RequireAuth({ children }) {
  const { user, loading } = useSession();
  const location = useLocation();

  if (loading) return <p className="muted">Loading...</p>;
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
